var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{attrs:{"size":"small"},on:{"change":_vm.onSelectChanged},model:{value:(_vm.displayType),callback:function ($$v) {_vm.displayType=$$v},expression:"displayType"}},[_c('el-radio-button',{attrs:{"label":2}},[_vm._v("图表")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("列表")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d96dc01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/DisplayType.vue
// module id = null
// module chunks = 